<div class="row justify-content-center my-4">
  <div class="col col-sm-10 col-md-7 col-lg-6 col-xl-5 col-xxl-4">
    <div class="card shadow-lg">
      <div class="card-body p-0">
        <app-header></app-header>
        <main>
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</div>
